import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import b4 from '../../assets/b4.png';
import b2 from '../../assets/b2.png';
import b3 from '../../assets/b3.png';
import b from '../../assets/b.png';

// Composant pour les icônes
const Icone = ({ icon, color }) => (
    <div className={`rounded-full flex items-center justify-center ${color}`}>
        {icon}
    </div>
);

// Composant pour les cartes
const Carte = ({ bgColor, icon, titre, texte, textPosition, width }) => (
    <div className={`flex flex-col items-center m-2 rounded-xl shadow ${bgColor} `}>
        <Icone icon={icon} color={width} />
        <h3 className="font-semibold mt-2 text-black">{titre}</h3>
        <p className={`text-graybadge mt-1 text-sm ${textPosition}`}>{texte}</p>
    </div>
);
const Badges = () => {
    const badges = [
        {
            bgColor: "!py-6 !rounded-xl",
            icon: <img src={b} alt="Bronze Badge" className="size-16 rounded-full" />,
            titre: "Bronze",
            texte: "5+ tâches complétées",
        },
        {
            bgColor: "!py-6 !rounded-xl",
            icon: <img src={b2} alt="Argent Badge" className="size-16 rounded-full" />,
            titre: "Argent",
            texte: "15+ tâches complétées",
        },
        {
            bgColor: "!py-6 !rounded-xl",
            icon: <img src={b3} alt="Or Badge" className="size-16 rounded-full" />,
            titre: "Or",
            texte: "30+ tâches complétées",
        },
        {
            bgColor: "!py-6 !rounded-xl",
            icon: <img src={b4} alt="Platine Badge" className="size-16 rounded-full" />,
            titre: "Platine",
            texte: "50+ tâches complétées",
        },
    ];

    return (
        <div className="">
            {/* Grille sur écrans moyens et larges */}
            <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                {badges.map((badge, index) => (
                    <Carte
                        key={index}
                        bgColor={badge.bgColor}
                        icon={badge.icon}
                        titre={badge.titre}
                        texte={badge.texte}
                    />
                ))}
            </div>

            {/* Carrousel sur les petits écrans */}
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={20}
                slidesPerView={1}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                pagination={{
                    clickable: true,
                    bulletClass: "swiper-pagination-bullet",
                    bulletActiveClass: "swiper-pagination-bullet-active",
                }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                className="md:hidden">
                {badges.map((badge, index) => (
                    <SwiperSlide key={index}>
                        <Carte
                            bgColor={badge.bgColor}
                            icon={badge.icon}
                            titre={badge.titre}
                            texte={badge.texte}
                        />
                    </SwiperSlide>
                ))}
                {/* Boutons de navigation personnalisés */}
                <div
                    className="swiper-button-prev text-orange hover:text-[#E67C00] "
                    role="button"
                ></div>
                <div
                    className="swiper-button-next text-orange hover:text-[#E67C00]"
                    role="button"
                ></div>
            </Swiper>

            {/* Styles pour personnaliser les points */}
            <style>
                {`
                .swiper-pagination-bullet {
                    background: orange;
                    opacity: 0.6;
                    height:3px;
                    width:3px;
                }
                .swiper-pagination-bullet-active {
                    background: orange;
                    opacity: 1;
                    
                }
                .swiper-button-next,
                .swiper-button-prev {
                    font-size: 16px;
                    width: 30px; 
                    height: 30px;
                }

                .swiper-button-next::after,
                .swiper-button-prev::after {
                    font-size: 16px; 
                }
                `}
            </style>
        </div>
    );
};

export default Badges;
